import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Phone, PhoneOff, Video } from 'lucide-react';
import { assets } from '../../assets/assets';
import { getPhotoUrl } from '../../utils/imageUtils';
import { playRingtone } from './ringtone';

/** Fenêtre « X vous appelle » avec Accepter / Refuser */
const IncomingCallModal = ({ call, onAccept, onDecline }) => {
  useEffect(() => playRingtone('incoming'), [call?.callId]);

  const photo = call.caller?.profileImageUrl ? getPhotoUrl(call.caller.profileImageUrl) : null;
  const isVideo = call.kind === 'video';

  return createPortal(
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-[10050] p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-xs text-center" role="dialog" aria-modal="true" aria-label="Appel entrant">
        <div className="relative mx-auto w-20 h-20 mb-4">
          <span className="absolute inset-0 rounded-full bg-[#0026E2]/20 animate-ping" aria-hidden />
          <img
            src={photo || assets.employes}
            alt=""
            className="relative w-20 h-20 rounded-full object-cover border-2 border-[#0026E2]"
            onError={(e) => { e.target.src = assets.employes; }}
          />
        </div>
        <p className="text-base font-bold text-gray-900 truncate">{call.caller?.nom_complet || 'Un membre'}</p>
        <p className="text-sm text-gray-500 truncate">{call.projetNom || 'Projet'}</p>
        <p className="text-xs text-gray-400 mt-1">{isVideo ? 'Appel vidéo entrant…' : 'Appel vocal entrant…'}</p>

        <div className="mt-6 flex items-center justify-center gap-10">
          <div className="flex flex-col items-center gap-1">
            <button
              type="button"
              onClick={onDecline}
              className="w-14 h-14 rounded-full bg-red-600 hover:bg-red-700 text-white flex items-center justify-center shadow-lg transition-colors"
              aria-label="Refuser"
            >
              <PhoneOff size={24} />
            </button>
            <span className="text-xs text-gray-600">Refuser</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <button
              type="button"
              onClick={onAccept}
              className="w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-lg transition-colors"
              aria-label="Accepter"
            >
              {isVideo ? <Video size={24} /> : <Phone size={24} />}
            </button>
            <span className="text-xs text-gray-600">Accepter</span>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default IncomingCallModal;
